import React from 'react';
import {
    Box,
    Typography,
    Paper,
    List,
    ListItem,
    ListItemText,
    Container,
    Divider
} from '@mui/material';

export default function Intro() {
    return (
        <Container maxWidth="xl">
            <Box sx={{
                flexGrow: 1,
                p: { xs: 2, sm: 3, md: 4 },
                display: 'flex',
                alignItems: 'center'
            }}>
                <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
                    <Typography variant="h4" gutterBottom>
                        ASP.NET Core Minimal API Eğitimi
                    </Typography>

                    <Typography variant="body1" paragraph>
                        Bu açık ders, ASP.NET Core Minimal Web API’ler konusunda temel beceriler kazanmanıza yardımcı olacak kapsamlı bir rehberdir. 20 adet açıklayıcı YouTube videosu, 13 sunum ve 1 GitHub deposu içeren bu eğitim, başlangıçtan ileri seviyeye kadar tüm kullanıcıları hedefler. RESTful API geliştirme, CORS yönetimi, global hata yakalama, doğrulama, bağımlılık enjeksiyonu, AutoMapper ve daha fazlasını öğreneceksiniz. Pratik örnekler ve gerçek dünyadan uygulamalarla desteklenen bu içerik, projelerinizi profesyonel bir seviyeye taşımak için gerekli bilgi ve araçları sunar. Başlamak için tüm materyallere göz atmayı unutmayın!
                    </Typography>

                    <Typography variant="body1" paragraph>

                    </Typography>



                    <Divider sx={{ my: 3 }} />

                    <Typography variant="body1">
                        Bu ders, ASP.NET Core Minimal API'leri hakkında derinlemesine bilgi edinmek isteyenler için kapsamlı bir kaynaktır.
                    </Typography>
                </Paper>
            </Box>
        </Container>
    );
}
